import IApplicationState from 'app/types/state';
import { ITeamsState, ITeamsSelector } from 'app/ducks/teams/types';
import _ from 'lodash';

import { getPaymentIdsByTeamId } from 'app/ducks/payments/selectors';
import { getPaymentCollectionIdsByTeamId } from 'app/ducks/paymentCollections/selectors';
import { getOrganisationById } from 'app/ducks/organisations/selectors';
import { getGroupById, getGroupsByIdInSelectFormat } from 'app/ducks/groups/selectors';
import { getOrganisationSectionById } from 'app/ducks/organisationSections/selectors';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.teams.teamsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getTeamsFilteredByTagInSelectFormat(
  state: IApplicationState,
  tagId,
): any {
  const { teamsById }: ITeamsState = state.teams;
  const teams = _.filter(teamsById, { tags: [tagId] });
  const mappedTeams = _.map(teams, (n) => mapSelect(state, n.id));
  return mappedTeams;
}

export function getTeamsByIdInSelectFormat(state): any {
  const { teamIds } = state.teams;
  const mappedTeams = _.map(teamIds, (n) => mapSelect(state, n));
  return mappedTeams;
}

export function getTeamConnectionsByIdInSelectFormat(teamConnections): any {
  const mappedTeamConnections = _.map(teamConnections, (n) => ({
    id: n.id,
    name: `${n.competitionName} - ${n.teamName}`,
  }));
  return mappedTeamConnections;
}

export function getTeamsFilteredByClubById(teamsById, clubId) {
  const filteredTeams = _.filter(teamsById, {
    club: { id: clubId },
  });
  const teamIds = _.map(filteredTeams, 'id');
  const parsedTeamsById = _.pick(teamsById, teamIds);

  return {
    teamsById: parsedTeamsById,
    teamIds,
  };
}

export function getTeamSummary(team): any {
  // let status = {
  //   paymentStatus: 'Up to Date',
  //   paymentStatusColour: 'green',
  // };
  // const amount = team.paymentStatusAmount;
  // switch (team.paymentStatus) {
  //   case 'owing':
  //     status = `Owing ${amount}`;
  //     break;
  //   case 'overdue':
  //     status = `Overdue ${amount}`;
  //     break;
  //   default:
  //     status = 'Up to Date';
  //     break;
  // }

  const teamSummary = {
    id: team.id,
    name: {
      name: team.name,
      connected: (!_.isEmpty(team.teamConnections) && team.teamConnections?.length > 0),
    },
    seasonName: team.seasonName,
    financialStatus: {
      owingNumber: team.pendingPaymentCollectionsTotalCount,
      overdueNumber: team.overduePaymentCollectionsTotalCount,
    },
    numberOfTeamMembers: team.numberOfTeamMembers,
  };
  return teamSummary;
}

export function getTeamMemberIds(state, teamId): any {
  if (state.teams.teamsById !== undefined && teamId !== undefined) {
    return state.teams.teamsById[teamId].teamMembers;
  }
  return [];
}

export const getPaymentCollectionIds = (state, teamId): any => {
  getPaymentCollectionIdsByTeamId(state, teamId);
};

export function getPaymentIds(state, teamId): any {
  return getPaymentIdsByTeamId(state, teamId);
}

export function getCurrentTeam(state): any {
  if (
    state.teams !== undefined
    && state.teams.teamsById !== undefined
    && state.teams.currentTeamId !== undefined
    && !_.isEmpty(state.teams.teamsById[state.teams.currentTeamId])
  ) {
    const findTeam = state.teams.teamsById[state.teams.currentTeamId];
    const groupId = findTeam.group !== undefined ? findTeam.group.id : null;
    const currentTeam = {
      ...findTeam,
      connectedToAssociation:
        (!_.isEmpty(findTeam.teamConnections) && findTeam.teamConnections?.length > 0),
      payments: getPaymentIds(state, state.teams.currentTeamId),
      paymentCollections: getPaymentCollectionIds(
        state,
        state.teams.currentTeamId,
      ),
      organisation: {
        ...findTeam.organisation,
        ...getOrganisationById(state, findTeam.organisationId),
      },
      group: {
        ...findTeam.group,
        ...getGroupById(state, groupId),
      },
    };

    return currentTeam;
  }
  return {};
}

export function getGroupIds(state: IApplicationState) {
  const arrGroupIds = [];
  _.each(state.teams.teamsById, (team) => {
    if (!_.isEmpty(team?.group?.id)) {
      arrGroupIds.push(team.group.id);
    }
  });
  return arrGroupIds;
}

export function getCurrentFormTeam(state: IApplicationState) {
  return {
    ...getCurrentTeam(state),
    ...state.teams.requestedData,
  };
}

export function getTeams(state): ITeamsSelector {
  return {
    ...state.teams,
    currentTeam: getCurrentTeam(state),
    currentFormTeam: getCurrentFormTeam(state),
    groupIds: getGroupIds(state),
    teamsByIdInSelectFormat: getTeamsByIdInSelectFormat(state),
    getTeamsFilteredByTagInSelectFormat: (tagId): any => getTeamsFilteredByTagInSelectFormat(state, tagId),
  };
}
